import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ensureHomeData } from './feature-access';

export const gatewayGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const homeData = await ensureHomeData();

  if (homeData?.hasGateway === true) {
    return true;
  }

  return router.parseUrl('/home');
};
